"use client"

import React from 'react'

interface ClientErrorBoundaryProps {
  children: React.ReactNode
}

interface ClientErrorBoundaryState {
  hasError: boolean
  error?: Error
}

export default class ClientErrorBoundary extends React.Component<
  ClientErrorBoundaryProps,
  ClientErrorBoundaryState
> {
  constructor(props: ClientErrorBoundaryProps) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error: Error) {
    console.error('[ClientErrorBoundary] Caught error:', error)
    return { hasError: true }
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('[ClientErrorBoundary] Component stack:', info.componentStack)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '1.5rem',
          textAlign: 'center'
        }}>
          <div style={{ maxWidth: '400px' }}>
            <h1 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '0.5rem' }}>
              Something went wrong
            </h1>
            <p style={{ fontSize: '0.875rem', color: '#6b7280', marginBottom: '0.5rem' }}>
              An unexpected error occurred while rendering this page.
            </p>
            <p style={{ fontSize: '0.75rem', color: '#9ca3af' }}>
              Check the browser console for the component stack.
            </p>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}
